module.exports = __webpack_public_path__ + "static/media/logo.e8983306.png";